import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import host from '../../urlPath';
//******* 

//--------- INSERT
export const createUser = createAsyncThunk("createUser", async (formData, { rejectWithValue }) => { 
    const response = await axios.post(`${host}/client_master.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    try {
        const result = await response.data.success;
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})



//--------- EDIT
export const updateUser = createAsyncThunk("updateUser", async (formData, { rejectWithValue }) => {

    const response = await axios.post(`${host}/client_master.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    try {
        const result = await response.data.success;
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})




//--------- ADD TO FAVOURITE
export const addToFavourite = createAsyncThunk("addToFavourite", async (id, { rejectWithValue }) => {
    const response = await fetch(`${host}/client_master.php/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
    });
    try {
        const result = await response.json();
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})


//=---------- READ
export const showUserData = createAsyncThunk("showUserData", async (args, { rejectWithValue }) => {

    const response = await fetch(`${host}/client_master.php`, {
        method: "GET", // *GET, POST, PUT, DELETE, etc. 
        headers: {
            "Content-Type": "application/json"
        }
    });
    try {
        const result = await response.json();
        return result;

    } catch (error) {
        return rejectWithValue(error)
    }
})


//--------- DELETE
export const deleteuser = createAsyncThunk("deleteuser", async (id, { rejectWithValue }) => {
    const response = await fetch(`${host}/client_master.php/${id}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        },
    });
    try {
        const result = await response.json();
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})

 


//--------- DELETE ALL USERS
export const deleteAllUsers = createAsyncThunk("deleteAllUsers", async (args,{ rejectWithValue }) => {
    
    const response = await axios.delete(`${host}/client_master_delete_all.php`, {
        headers: { 'Content-Type': 'application/json' },
    });

    try {
        const result = await response.data;
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})



//--------- EDIT CLIENT
export const selectsingleclient = createAsyncThunk("selectsingleclient", async (id, { rejectWithValue }) => { 
    
    const response = await fetch(`${host}/client_master_edit.php/${id}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    try {
        const result = await response.json();
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})


//--------- INSERT
export const csvClientAdd = createAsyncThunk("csvClientAdd", async (formData, { rejectWithValue }) => {
    const response = await axios.post(`${host}/client_master_csv_add.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    try { 
        const result = await response.data;
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})


 
 
//*************************************** FOR API END *************************


export const clientmaster = createSlice({
    name: "clientmaster",
    initialState: {
        usersdata: [],
        singleuserdata: [],
        loading: false,
        error: null,
        clientID: "",
        activetab: "show_all",
        urlparameter: ""
    },

    // //*************************************** FOR WITHOUT API ONLY FUNCTION START *************************   
    reducers: {
        selectClientId: (state, action) => {
            state.clientID = action.payload
        },
        changeActiveTab: (state, action) => {
            state.activetab = action.payload
        },
        changeUrlParameter: (state, action) => {
            state.urlparameter = action.payload
        }, 
    },
    //*************************************** FOR WITHOUT API ONLY FUNCTION END *************************


    //*************************************** FOR API START *************************
    extraReducers: (builder) => {

        //-------------------- FOR INSERT -------------------------
        builder.addCase(createUser.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(createUser.fulfilled, (state, action) => {
            state.loading = false;
            state.mobilenoCheck = action.payload;
        })
        builder.addCase(createUser.rejected, (state) => {
            state.loading = false;
        })
        //---------------------- END --------------------------

        //-------------------- FOR UPDATE -------------------------
        builder.addCase(updateUser.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(updateUser.fulfilled, (state, action) => {
            state.loading = false;
            state.mobilenoCheck = action.payload;
        })
        builder.addCase(updateUser.rejected, (state) => {
            state.loading = false;
        })
        //---------------------- END --------------------------


        //---------------------- FOR SELECT ---------------------------
        builder.addCase(showUserData.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(showUserData.fulfilled, (state, action) => {
            state.loading = false;
            state.usersdata = action.payload;
        })
        builder.addCase(showUserData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        //---------------------- END --------------------------


        //---------------------- FOR DELETE ---------------------------
        builder.addCase(deleteuser.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(deleteuser.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload.id) {
                state.usersdata = state.usersdata.filter((ele) => ele.id !== action.payload.id)
            }


        })
        builder.addCase(deleteuser.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        //---------------------- END --------------------------


         //-------------------- FOR delete All Users-------------------------
         builder.addCase(deleteAllUsers.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(deleteAllUsers.fulfilled, (state) => {
            state.loading = false;  
        })
        builder.addCase(deleteAllUsers.rejected, (state) => {
            state.loading = false;
        })
        //---------------------- END --------------------------




        //-------------------- FOR UPDATE -------------------------
        builder.addCase(addToFavourite.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(addToFavourite.fulfilled, (state, action) => {
            state.loading = false;
            for (let index = 0; index < state.usersdata.length; index++) {
                const element = state.usersdata[index];
                if (element.id === action.payload.id) {
                    state.usersdata[index].favourite_flag = action.payload.favourite_flag;
                    break;
                }
            }
        })
        builder.addCase(addToFavourite.rejected, (state) => {
            state.loading = false;
        })
        //---------------------- END --------------------------



        //-------------------- FOR selectsingleclient  -------------------------
        builder.addCase(selectsingleclient.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(selectsingleclient.fulfilled, (state,action) => {
            state.singleuserdata = action.payload;  
        })
        builder.addCase(selectsingleclient.rejected, (state) => {
            state.loading = false;
        })
        //---------------------- END --------------------------


        //-------------------- FOR INSERT CSV -------------------------
         builder.addCase(csvClientAdd.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(csvClientAdd.fulfilled, (state) => {
            state.loading = false; 
        })
        builder.addCase(csvClientAdd.rejected, (state) => {
            state.loading = false;
        })
        //---------------------- END --------------------------



        //*************************************** FOR API END ************************* 
    },

});
export default clientmaster.reducer;
export const { selectClientId, changeActiveTab,changeUrlParameter } = clientmaster.actions; // FOR EXPORT REDUCERS